import { ReactElement } from "react";

import { EndpointType } from "./Endpoints";
import JsonView from "../molecules/JsonView";
import ParsingResultLAHtmlView from "../molecules/ParsingResultLAHtmlView";
import ParsingResultLAPreview from "../molecules/ParsingResultLAPreview";
import ParsingResultOCR from "../molecules/ParsingResultOCR";
import ParsingResultTable from "../molecules/ParsingResultTable";

export type ViewType = "preview" | "html" | "json";
export type DownloadFileType = Exclude<ViewType, "preview">;

export const DEFAULT_VIEW_TYPE = "preview";

export const VIEW_LABELS: Record<ViewType, string> = {
  preview: "Preview",
  html: "HTML",
  json: "JSON",
};

/**
 * Endpoint와 View 조합에 따른 컴포넌트를 반환하는 함수
 * @param dragging - 드래그 상태에 따라 일부 컴포넌트에 prop 전달
 */
export const getEndpointViewComponents = (
  dragging: boolean,
): Record<EndpointType, Partial<Record<ViewType, ReactElement>>> => ({
  extractor: {
    preview: <ParsingResultTable disabled={dragging} />,
    json: <JsonView />,
  },
  ocr: {
    preview: <ParsingResultOCR disabled={dragging} />,
    json: <JsonView />,
  },
  "layout-analysis": {
    preview: <ParsingResultLAPreview />,
    html: <ParsingResultLAHtmlView disabled={dragging} />,
    json: <JsonView />,
  },
});

export const getEndpointViewTypes = (
  endpointType: EndpointType,
): ViewType[] => {
  const components = getEndpointViewComponents(false)[endpointType];
  if (!components) return [];
  return Object.keys(components) as ViewType[];
};

export const getViewLabel = (viewType: ViewType): string => {
  return VIEW_LABELS[viewType] ?? viewType;
};
